class Video {
  constructor() {
    this.videoThumbnails = document.querySelectorAll('.ns-video__thumbnail-container');
    if (this.videoThumbnails.length > 0) {
      this.init();
    }
  }

  init() {
    this.videoThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        // Add a small delay if needed
        setTimeout(() => {
          // Get the corresponding .ns-video__video-container in the same "block"
          const videoInner = thumbnail.closest('.ns-video__inner');
          if (!videoInner) return;

          const videoContainer = videoInner.querySelector('.ns-video__video-container');
          if (!videoContainer) return;

          // Pause all other videos/iframes
          this.pauseAllOtherVideos(videoContainer);

          // Hide the thumbnail and play icon
          thumbnail.classList.add('fade-out');
          thumbnail.style.display = 'none';

          // Check for iframe or video
          const iframe = videoContainer.querySelector('iframe');
          const htmlVideo = videoContainer.querySelector('video');

          if (iframe && !htmlVideo) {
            // Play iframe video (e.g. YouTube)
            this.playIframeVideo(iframe);
          } else if (htmlVideo && !iframe) {
            // Play HTML5 video
            htmlVideo.play();
          } else if (iframe && htmlVideo) {
            // If both exist, define a priority. For example, prefer iframe:
            this.playIframeVideo(iframe);
          }
        }, 200);
      });
    });
  }

  pauseAllOtherVideos(currentContainer) {
    // Pause all HTML5 videos not in current container
    const allVideos = document.querySelectorAll('.ns-video__video-container video');
    allVideos.forEach(video => {
      if (!currentContainer.contains(video)) {
        video.pause();
        video.currentTime = 0;
      }
    });

    // Reset all iframes not in current container
    const allIframes = document.querySelectorAll('.ns-video__video-container iframe');
    allIframes.forEach(iframe => {
      if (!currentContainer.contains(iframe)) {
        // Remove autoplay parameter if it exists
        let src = iframe.src.replace(/[?&]autoplay=1/g, '');
        if (iframe.src !== src) {
          iframe.src = src; // This will reload the iframe without autoplay
        }
      }
    });
  }

  playIframeVideo(iframe) {
    let currentSrc = iframe.src;
    // Add autoplay parameter if not present
    if (!/[\?&]autoplay=1/.test(currentSrc)) {
      currentSrc += currentSrc.includes('?') ? '&autoplay=1' : '?autoplay=1';
    }
    iframe.src = currentSrc;
  }
}

export default Video;
